import { InjectionToken } from '@angular/core';
import { WatchlistChangeAction, WatchlistEntity, WatchlistMappingEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface UpdateWatchlistHandlerService {
  watchlistChanges$: Observable<WatchlistChangeAction>;
  /**
   * Creates a warning from a subsystem when deleting a watchlist.
   * @param watchlist
   */
  removeWatchlistWarning(watchlist: WatchlistEntity): Observable<string | null>;

  /**
   * Creates a warning from a subsystem when deleting a company from a watchlist.
   * @param watchlistMapping
   */
  removeWatchlistMappingWarning(watchlistMapping: WatchlistMappingEntity): Observable<string | null>;
  addToWatchlistWarning(watchlistUuid: string): Observable<string | null>;
  registerWatchlistChange(change: WatchlistChangeAction): void;
}

export const UPDATE_WATCHLIST_MAPPING_HANDLER_SERVICE_TOKEN = new InjectionToken<UpdateWatchlistHandlerService[]>(
  'UpdateWatchlistHandler',
);
